export const accessTableConfig = {
  title: '',
  propList: [
    {
      prop: 'channel',
      label: '渠道',
      minWidth: '60'
    },
    {
      prop: 'content',
      label: '访问内容',
      minWidth: '120',
      slotName: 'content'
    },
    { prop: 'deptName', label: '所属部门', minWidth: '60' },
    { prop: 'empName', label: '所属员工', minWidth: '60' },
    { prop: 'accessTime', label: '访问时间', minWidth: '120' },
    {
      prop: 'duration',
      label: '访问时长(min)',
      minWidth: '60',
      slotName: 'duration'
    }
  ]
}
